const comments = [
  {
    avatar: 'R',
    name: '漫友小樱花',
    time: '2小时前',
    content: '汗汗漫画的阅读体验真的太好了！下拉式连续看不用一直点翻页，追《社内恋爱法则》一口气看了五十话，爽到飞起！',
    likes: 328,
  },
  {
    avatar: 'K',
    name: '追漫小王子',
    time: '5小时前',
    content: '国漫分类做得很全，想看的《重生之都市仙尊》和《斗破苍穹》都有，更新速度也快，每天第一时间就能看到最新话。',
    likes: 256,
  },
  {
    avatar: 'M',
    name: '吃货漫迷',
    time: '8小时前',
    content: '从韩漫到日漫到国漫全覆盖，种类太丰富了！而且页面加载真的很快，在地铁上用手机看都不卡，强烈推荐！',
    likes: 189,
  },
  {
    avatar: 'Y',
    name: '深夜追漫人',
    time: '1天前',
    content: '画质高清这一点必须夸，有些平台的图很模糊，汗汗这边每张图都很清晰，看着特别舒服，已经安利给所有朋友了。',
    likes: 412,
  },
  {
    avatar: 'L',
    name: '漫画种草机',
    time: '1天前',
    content: '分类清晰、更新及时、阅读流畅，这三点就够我死心塌地了。希望平台越做越好，多上一些冷门佳作！',
    likes: 145,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">漫友热评</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            听听漫友们怎么说，真实用户阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className={`p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 ${
                idx === 0 ? 'md:col-span-2' : ''
              }`}
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center font-heading text-sm flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-900">{item.name}</span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <div className="flex gap-0.5 mt-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs text-secondary-400"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
              <div className="flex items-center gap-1 mt-3 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}